import { api } from '../api';
import type { ExportJobRow } from './exportsApi';
import type { OperationalAssociationCard, OperationalSearchResponse } from './operationalSearchApi';

export interface RequirenteSummaryRow {
  contextId: number;
  name: string;
  path: string | null;
  profiles: Array<{ id: number; name: string }>;
  associationCount: number;
}

export interface RequirenteListResponse {
  scope: {
    mode: 'admin' | 'requirente' | 'none';
    primaryContextId: number | null;
  };
  items: RequirenteSummaryRow[];
}

export interface RequirenteAccessScope {
  mode: 'admin' | 'requirente' | 'none';
  allowedContextIds: number[] | null;
  primaryContextId: number | null;
}

export const requirentesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listRequirentes: builder.query<RequirenteListResponse, void>({
      query: () => '/requirentes',
      providesTags: [{ type: 'Compliance', id: 'REQUIRENTES' }],
    }),
    getRequirenteScope: builder.query<RequirenteAccessScope, void>({
      query: () => '/requirentes/scope',
      providesTags: [{ type: 'Compliance', id: 'REQUIRENTE_SCOPE' }],
    }),
    getRequirenteAssociations: builder.query<
      OperationalSearchResponse & { contextId: number },
      { contextId: number; identifiers?: string[]; limit?: number; offset?: number }
    >({
      query: ({ contextId, identifiers, limit, offset }) => ({
        url: `/requirentes/${contextId}/associations/filter`,
        method: 'POST',
        body: {
          identifiers: identifiers ?? [],
          limit,
          offset,
        },
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Compliance', id: `REQUIRENTE_${arg.contextId}` }],
    }),
    exportRequirenteExcel: builder.mutation<
      ExportJobRow,
      { contextId: number; associationIds?: number[]; identifiers?: string[] }
    >({
      query: ({ contextId, ...body }) => ({
        url: `/requirentes/${contextId}/export/excel`,
        method: 'POST',
        body,
      }),
    }),
    exportRequirenteZip: builder.mutation<
      ExportJobRow,
      { contextId: number; associationIds?: number[]; identifiers?: string[] }
    >({
      query: ({ contextId, ...body }) => ({
        url: `/requirentes/${contextId}/export/zip`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useListRequirentesQuery,
  useGetRequirenteScopeQuery,
  useGetRequirenteAssociationsQuery,
  useExportRequirenteExcelMutation,
  useExportRequirenteZipMutation,
} = requirentesApi;

export type { OperationalAssociationCard };
